module.exports = __webpack_public_path__ + "img/rou.d8fca321.png";